import { SMITHERS_DEVICE_COLUMNS, type SmithersDeviceColumn } from "@/lib/smithers-device-columns"
import { getSmithersClientListHistoryState, type SmithersClientListHistoryState } from "@/lib/smithers-client-navigation"

export const SMITHERS_DEVICE_PAGE_SIZES = [25, 50, 100, 200] as const

export interface SmithersDeviceListHistoryState {
  clientId: string | null
  page: number
  pageSize: number
  filter: string
  searchInput: string
  sortBy: Exclude<SmithersDeviceColumn, "id" | "proVenueInstances">
  sortDirection: "asc" | "desc"
  clientList?: SmithersClientListHistoryState
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

export function getSmithersDeviceListHistoryState(state: unknown): SmithersDeviceListHistoryState | undefined {
  if (!isRecord(state) || !isRecord(state.smithersDeviceList)) return undefined
  const snapshot = state.smithersDeviceList
  const pageSize = snapshot.pageSize === undefined ? 50 : snapshot.pageSize
  const clientList = getSmithersClientListHistoryState({ smithersClientList: snapshot.clientList })
  if (
    !(snapshot.clientId === null || typeof snapshot.clientId === "string") ||
    !Number.isSafeInteger(snapshot.page) || Number(snapshot.page) < 1 ||
    !SMITHERS_DEVICE_PAGE_SIZES.some((size) => size === pageSize) ||
    typeof snapshot.filter !== "string" || typeof snapshot.searchInput !== "string" ||
    !SMITHERS_DEVICE_COLUMNS.some(({ key }) => key !== "id" && key !== "proVenueInstances" && key === snapshot.sortBy) ||
    (snapshot.sortDirection !== "asc" && snapshot.sortDirection !== "desc")
  ) return undefined
  return {
    clientId: snapshot.clientId,
    page: Number(snapshot.page),
    pageSize: pageSize as number,
    filter: snapshot.filter,
    searchInput: snapshot.searchInput,
    sortBy: snapshot.sortBy as SmithersDeviceListHistoryState["sortBy"],
    sortDirection: snapshot.sortDirection,
    ...(clientList ? { clientList } : {}),
  }
}

export function getSmithersDeviceListOrigin(state: unknown): SmithersDeviceListHistoryState | undefined {
  if (!isRecord(state) || state.fromSmithersDeviceList !== true) return undefined
  return getSmithersDeviceListHistoryState(state)
}

export function smithersDeviceListPath(clientId: string | null): string {
  return `/smithers/devices${clientId === null ? "" : `?${new URLSearchParams({ clientId })}`}`
}
